import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { App, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress/src'
import { Lang } from 'laravel-vue-lang'
import Notify from 'vue2-notify'

InertiaProgress.init()
const el = document.getElementById('app')
let initialPage = JSON.parse(el.dataset.page)

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(plugin)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(Lang, {
	locale: initialPage.props.locale,
	fallback: 'fr',
})

Vue.use(Notify, {
    enter: 'fadeIn',
    leave: 'fadeOut',
    duration: 300,
    visibility: 5000,
    position: 'bottom-right',
    itemClass: 'flash-message',
    //permanent: true,
    width: false,
    closeButtonClass: 'close',
})

const types = {
    info: { itemClass: 'info', iconClass: 'icon info'},
    error: { itemClass: 'error', iconClass: 'icon error'},
    warning: { itemClass: 'warning', iconClass: 'icon warning'},
    success: { itemClass: 'success', iconClass: 'icon success'},
}
Vue.$notify.setTypes(types)

new Vue({
  metaInfo: {
    titleTemplate: 'Gestion de cave à vin',
  },
  render: h =>
    h(App, {
      props: {
        initialPage: initialPage,
        resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
      },
    }),
}).$mount(el)
